import { AlertDialog, AlertDialogBody, AlertDialogContent, AlertDialogFooter, AlertDialogHeader, AlertDialogOverlay, Avatar, Badge, Box, Breadcrumb, BreadcrumbItem, BreadcrumbLink, Button, Card, CardBody, Drawer, DrawerBody, DrawerCloseButton, DrawerContent, DrawerHeader, DrawerOverlay, Flex, FormControl, FormLabel, Heading, IconButton, Image, Input, Menu, MenuButton, MenuItem, MenuList, Modal, ModalBody, ModalCloseButton, ModalContent, ModalFooter, ModalHeader, ModalOverlay, Select, SimpleGrid, Skeleton, SkeletonText, Stack, Stat, StatLabel, StatNumber, Text, useColorMode, useColorModeValue, useToast } from '@chakra-ui/react'
import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useLocation, useNavigate } from 'react-router-dom'
import { useStateContext } from '../../../context/ContextProvider'
import axiosClient from '../../../axios-client'
import { MdAdd, MdDelete, MdOutlineHeadsetMic } from 'react-icons/md'
import { GrDeliver } from "react-icons/gr";
import { FaBoxOpen } from "react-icons/fa";
import { CiEdit, CiMenuKebab } from 'react-icons/ci'
import { FiEdit3 } from 'react-icons/fi'
import { TiShoppingCart } from "react-icons/ti";
import ReactSelect from 'react-select'
import { RiCoupon3Fill } from 'react-icons/ri'
import { IoMdPricetags } from "react-icons/io";
import { BsCart4 } from "react-icons/bs";
import countriesData from '../../../assets/dataJson/countries.json';
import { handlePriceChange, formatPriceForBackend } from '../../../utils/priceFormatter';
import { AsyncPaginate } from 'react-select-async-paginate'; let isFirstLoad_Details_GestConfirmation = true;
function Details_GestConfirmation() {
    const location = useLocation()
    const navigate = useNavigate()
    const { t } = useTranslation();
    const { user, setToken, setUser, currentBusiness } = useStateContext();
    const toast = useToast()

    const [statusConfirmation, setStatusConfirmation] = useState('')
    const [statusStock, setStatusStock] = useState('')
    const [statusDelivery, setStatusDelivery] = useState('')
    const [loading, setLoading] = useState(false)

    const [detailOrder, setDetailOrder] = useState()
    const [productsOrderData, setProductsOrderData] = useState([])


    const [dataCoupon, setDataCoupon] = useState([])
    const [couponSelected, setCouponSelected] = useState()

    const [dataInfoClient, setDataInfoClient] = useState([])

    const fetchData = async () => {
        try {
            setLoading(true)
            await axiosClient.get(`commandes/${location.state.id}/`).then(async (res) => {
                setDetailOrder(res.data)
                await axiosClient.get(`/commandes/getdataOldOrdersClient/?id=${location.state.id}&clientPhone=${location.state.tel}&client_id=${user?.id}&business=${currentBusiness?.id}`, { hideLoader: !isFirstLoad_Details_GestConfirmation }).then(res => {
                    isFirstLoad_Details_GestConfirmation = false;
                    setDataInfoClient(res.data)

                    if (res.data.error === 'Client is disabled.' && res.data.etat === false) {
                        setUser({});
                        setToken(null);
                        localStorage.removeItem("tokenExpirationTime");
                        localStorage.removeItem("refreshTimeAdmin");
                        localStorage.removeItem("role");

                        // Vérifier si le toast n'est pas déjà affiché
                        if (!toast.isActive('accountDisabled')) {
                            toast({
                                id: 'accountDisabled',
                                description: t("le compte est désactivé"),
                                status: 'warning',
                                variant: 'left-accent',
                                duration: 2000,
                                isClosable: true,
                                position: 'bottom-right'
                            });
                        }
                    }
                })
            })
            await axiosClient.get(`/produitCommande/getProductsOrder/?commande=${location.state.id}&client_id=${user?.id}&userRole=${user?.role}`).then((res) => {

                if (res.data.error === 'Client is disabled.' && res.data.etat === false) {
                    setUser({});
                    setToken(null);
                    localStorage.removeItem("tokenExpirationTime");
                    localStorage.removeItem("refreshTimeAdmin");
                    localStorage.removeItem("role");

                    // Vérifier si le toast n'est pas déjà affiché
                    if (!toast.isActive('accountDisabled')) {
                        toast({
                            id: 'accountDisabled',
                            description: t("le compte est désactivé"),
                            status: 'warning',
                            variant: 'left-accent',
                            duration: 2000,
                            isClosable: true,
                            position: 'bottom-right'
                        });
                    }
                }

                setProductsOrderData(res.data)
            })
            await axiosClient.get(`/coupons/get_All_Coupons_For_New_Order/?client=${user?.id}&business=${currentBusiness?.id}`).then(res => {
                setDataCoupon(res.data)
            })
        } catch (error) {
            // console.log('ERROR : ', error);
            setLoading(false)
        }
    }
    useEffect(() => {
        if (user) {
            fetchData()
        }
    }, [user])

    // Manual shipping send
    const [loadingShipping, setLoadingShipping] = useState(false)
    const sendToShippingCompany = async () => {
        try {
            setLoadingShipping(true)
            await axiosClient.post(`commandes/${location.state.id}/send_to_shipping/`)
                .then(res => {
                    // console.log('RESPONSE SHIPPING: ', res);
                    if (res.data.success) {
                        toast({
                            description: res.data.message || t("Envoyé avec succès"),
                            status: 'success',
                            duration: 3000,
                            isClosable: true,
                            variant: 'left-accent',
                            position: 'bottom-right'
                        })
                    } else {
                        console.log('ERROR SHIPPING: 1 ', res.data.message);
                        let errorMsg = res.data.message || t("Échec de l'envoi");
                        if (res.data.details && res.data.details.length > 0) {
                            const detailsErrors = res.data.details
                                .map(d => `${d.company}: ${d.result.message}`)
                                .join(', ');
                            errorMsg = `${errorMsg} (${detailsErrors})`;
                        }
                        toast({
                            description: errorMsg,
                            status: 'error',
                            duration: 5000,
                            isClosable: true,
                            variant: 'left-accent',
                            position: 'bottom-right'
                        })
                    }
                })
        } catch (error) {
            console.log('ERROR SHIPPING: 2 ', error);
            toast({
                description: t("Erreur lors de l'envoi"),
                status: 'error',
                duration: 3000,
                isClosable: true,
                variant: 'left-accent',
                position: 'bottom-right'
            })
        } finally {
            setLoadingShipping(false)
        }
    }

    // Update status confirmation

    const [isAlertOpen, setIsAlertOpen] = useState(false);
    const cancelRef = React.useRef()
    const [statusId, setStatusId] = useState()

    const onOpenAlert = (id) => {
        setIsAlertOpen(true);
        setStatusId(id)
    };
    const onCloseAlert = () => {
        setIsAlertOpen(false);
        setStatusConfirmation('')
        setStatusId()
    };



    const HandleChangeStatus = async () => {
        try {
            await axiosClient.patch(`commandes/${location.state.id}/`, {
                status_confirmation: statusConfirmation
            }).then((res) => {
                setDetailOrder(prevData => {
                    return {
                        ...prevData,
                        status_confirmation: res.data.status_confirmation

                    }
                })
                // setDataOrder(dataOrder.map((item) => {
                //     if (item.id === res.data.id) {
                //         return {
                //             ...item,
                //             status_confirmation: res.data.status_confirmation
                //         }
                //     }
                //     return item
                // }))
                onCloseAlert()
                toast({
                    description: t("Statut est changé avec succès"),
                    status: 'success',
                    duration: 2000,
                    isClosable: true,
                    variant: 'left-accent',
                    position: 'bottom-right'
                })
            })
        } catch (error) {
            // console.log('ERROR : ', error);
        }
    }


    // Update status stock

    const [isAlertOpenStatusStock, setIsAlertOpenStatusStock] = useState(false);
    const cancelRefStatusStock = React.useRef()

    const onOpenAlertStatusStock = () => {
        setIsAlertOpenStatusStock(true)
    }

    const onCloseAlertStatusStock = () => {
        setIsAlertOpenStatusStock(false);
        setStatusStock('')
    };

    const HandleChangeStatusStock = async () => {
        try {
            await axiosClient.patch(`commandes/${location.state.id}/`, {
                status_stock: statusStock
            }).then((res) => {
                setDetailOrder(prevData => {
                    return {
                        ...prevData,
                        status_stock: res.data.status_stock

                    }
                })
                // setDataOrder(dataOrder.map((item) => {
                //     if (item.id === res.data.id) {
                //         return {
                //             ...item,
                //             status_confirmation: res.data.status_confirmation
                //         }
                //     }
                //     return item
                // }))
                onCloseAlertStatusStock()
                toast({
                    description: t("Statut est changé avec succès"),
                    status: 'success',
                    duration: 2000,
                    isClosable: true,
                    variant: 'left-accent',
                    position: 'bottom-right'
                })
            })
        } catch (error) {
            // console.log('ERROR : ', error);
        }
    }


    // Update status delivery

    const [isAlertOpenStatusDelivery, setIsAlertOpenStatusDelivery] = useState(false);
    const cancelRefStatusDelivery = React.useRef()

    const onOpenAlertStatusDelivery = () => {
        setIsAlertOpenStatusDelivery(true)
    }

    const onCloseAlertStatusDelivery = () => {
        setIsAlertOpenStatusDelivery(false);
        setStatusDelivery('')
    };

    const HandleChangeStatusDelivery = async () => {
        try {
            await axiosClient.patch(`commandes/${location.state.id}/`, {
                status_delivery: statusDelivery
            }).then((res) => {
                setDetailOrder(prevData => {
                    return {
                        ...prevData,
                        status_delivery: res.data.status_delivery

                    }
                })
                // setDataOrder(dataOrder.map((item) => {
                //     if (item.id === res.data.id) {
                //         return {
                //             ...item,
                //             status_confirmation: res.data.status_confirmation
                //         }
                //     }
                //     return item
                // }))
                onCloseAlertStatusDelivery()
                toast({
                    description: t("Statut est changé avec succès"),
                    status: 'success',
                    duration: 2000,
                    isClosable: true,
                    variant: 'left-accent',
                    position: 'bottom-right'
                })
            })
        } catch (error) {
            // console.log('ERROR : ', error);
        }
    }

    // Add or Update Coupon Command

    const [isAlertOpenCoupon, setIsAlertOpenCoupon] = useState(false);
    const cancelRefCoupon = React.useRef()

    const onOpenAlertCoupon = () => {
        setIsAlertOpenCoupon(true)
    }

    const onCloseAlertCoupon = () => {
        setIsAlertOpenCoupon(false);
        setCouponSelected()
    };

    const HandleChangeCoupon = async () => {
        const reduction = dataCoupon.find(e => e.id === parseInt(couponSelected)).reduction
        // console.log('Réduction : ', dataCoupon.find(e => e.id === parseInt(couponSelected)).reduction);
        try {
            await axiosClient.patch(`commandes/${location.state.id}/`, {
                coupon: couponSelected,
                priceWithCoupon: ((parseFloat(detailOrder?.price) - parseFloat(detailOrder?.price) * reduction / 100))
            }).then((res) => {
                setDetailOrder(prevData => {
                    return {
                        ...prevData,
                        coupon: res.data.coupon,
                        couponTitle: res.data.couponTitle,
                        priceWithCoupon: res.data.priceWithCoupon
                    }
                })
                // setDataOrder(dataOrder.map((item) => {
                //     if (item.id === res.data.id) {
                //         return {
                //             ...item,
                //             status_confirmation: res.data.status_confirmation
                //         }
                //     }
                //     return item
                // }))
                setCouponSelected()
                onCloseAlertCoupon()
                toast({
                    description: t("Coupon ajouté avec succès"),
                    status: 'success',
                    duration: 2000,
                    isClosable: true,
                    variant: 'left-accent',
                    position: 'bottom-right'
                })
            })
        } catch (error) {
            // console.log('ERROR : ', error);
        }
    }

    const deleteCoupon = async () => {
        try {
            await axiosClient.patch(`commandes/${location.state.id}/`, {
                coupon: null,
                priceWithCoupon: null
            }).then((res) => {
                setDetailOrder(prevData => {
                    return {
                        ...prevData,
                        coupon: null,
                        couponTitle: null
                    }
                })
                // setDataOrder(dataOrder.map((item) => {
                //     if (item.id === res.data.id) {
                //         return {
                //             ...item,
                //             status_confirmation: res.data.status_confirmation
                //         }
                //     }
                //     return item
                // }))
                onCloseAlertCoupon()
                toast({
                    description: t("Coupon supprimé avec succès"),
                    status: 'success',
                    duration: 2000,
                    isClosable: true,
                    variant: 'left-accent',
                    position: 'bottom-right'
                })
            })
        } catch (error) {
            // console.log('ERROR : ', error);
        }
    }

    //Drawer

    const [isDrawerOpen, setIsDrawerOpen] = useState(false);
    const drawerRef = React.useRef()

    const onOpenDrawer = () => {
        setIsDrawerOpen(true);
    };
    const onCloseDrawer = () => {
        setIsDrawerOpen(false);
    };



    // Modal Add Produt

    //Variables

    // Get Product 
    const [optionsTitre, setOptionsTitre] = useState([])
    const [productSelected, setProductSelected] = useState()

    const fetchProducts = async (userId, userRole) => {
        // Le fetching est maintenant géré dynamiquement par loadProductOptions
    }


    useEffect(() => {
        if (user?.id) {
            fetchProducts(user?.id, user?.role)
        }
    }, [user?.id])


    const [dataProducts, setDataProducts] = useState([])
    const [colorSelected, setColorSelected] = useState([])
    const [sizeSelected, setSizeSelected] = useState([])

    const loadProductOptions = async (search, loadedOptions, { page }) => {
        try {
            const res = await axiosClient.get(`/products/get_All_Products_names/?client=${user?.id}&page_size=20&page=${page}&search_term=${search}&userRole=${user?.role}&business=${currentBusiness?.id}`, { hideLoader: true });
            const results = res.data.results || [];
            const hasMore = res.data.next !== null && res.data.next !== undefined;

            return {
                options: results.map(product => ({
                    value: product.id,
                    label: product.title
                })),
                hasMore: hasMore,
                additional: {
                    page: page + 1,
                },
            };
        } catch (error) {
            // // console.error('Error fetching products', error);
            return { options: [], hasMore: false };
        }
    };
    const [imageProduct, setImageProduct] = useState()
    const [colorInput, setColorInput] = useState()
    const [sizeInput, setSizeInput] = useState()
    const [quantityInput, setQuantityInput] = useState()
    const [purchase_PriceInput, setPurchase_PriceInput] = useState()

    useEffect(() => {
        if (productSelected) {
            try {
                let colorOptions = []
                let sizeOptions = []
                axiosClient.get(`products/${productSelected.value}/?business=${currentBusiness?.id}`).then(res => {
                    setDataProducts(res.data)
                    setImageProduct(res.data?.images[0]?.image)
                    for (let index = 0; index < res.data.stock.length; index++) {
                        const color = res.data.stock[index].color;
                        const size = res.data.stock[index].size;

                        if (color && color.length !== 0) {
                            colorOptions.push({
                                value: res.data.stock[index].id,
                                label: color.toLowerCase()
                            });
                        }

                        if (size && size.length !== 0) {
                            sizeOptions.push({
                                value: res.data.stock[index].id,
                                label: size.toLowerCase()
                            });
                        }
                    }

                    // Supprimer les doublons pour les couleurs
                    colorOptions = Array.from(
                        new Map(colorOptions.map(item => [item.label.toLowerCase(), item])).values()
                    );

                    // Supprimer les doublons pour les tailles
                    sizeOptions = Array.from(
                        new Map(sizeOptions.map(item => [item.label.toLowerCase(), item])).values()
                    );
                    setColorSelected(colorOptions)
                    setSizeSelected(sizeOptions)
                })
            } catch (error) {
                // console.log('ERROR : ', error);
            }
        }
    }, [productSelected])

    const isNumericValid = (value) => {
        return /^\d+$/.test(value);
    };

    const isValidPrice = (value) => {
        return /^\d*\.?\d{0,2}$/.test(value.toString().replace(',', '.'));
    };


    const addProduct = async () => {
        try {

            // Validation des champs requis
            if (!productSelected || !quantityInput || !purchase_PriceInput) {
                toast({
                    description: t("Veuillez remplir tous les champs obligatoires"),
                    status: 'error',
                    variant: 'left-accent',
                    duration: 2000,
                    isClosable: true,
                    position: 'bottom-right'
                });
                return;
            }

            // Validation que quantité et prix sont des nombres
            if (!isNumericValid(quantityInput) || !isValidPrice(purchase_PriceInput)) {
                toast({
                    description: t("Le champ quantité doit contenir uniquement des chiffres et le prix un montant valide (ex: 10.22)"),
                    status: 'error',
                    variant: 'left-accent',
                    duration: 2000,
                    isClosable: true,
                    position: 'bottom-right'
                });
                return;
            }


            const payload = {
                product: productSelected.value,
                idCommande: location.state.id,
                color: colorInput ? colorInput.label : "",
                size: sizeInput ? sizeInput.label : "",
                quantity: parseInt(quantityInput),
                price: formatPriceForBackend(purchase_PriceInput)
            };

            await axiosClient.post(`produitCommande/createProduitCommande/`, payload).then(async (res) => {
                // console.log('RESPONSE: ', res.data);

                try {
                    const newPrice = (parseFloat(detailOrder?.price) + (formatPriceForBackend(purchase_PriceInput) * parseInt(quantityInput)))
                    await axiosClient.get(`commandes/${location.state.id}/`)
                        .then((res) => {
                            setDetailOrder(res.data)
                        })
                    toast({
                        description: t("Produit est ajouté avec succès"),
                        status: 'success',
                        duration: 2000,
                        isClosable: true,
                        variant: 'left-accent',
                        position: 'bottom-right'
                    })
                    setProductsOrderData(res.data)
                    onCloseModalAddProduct()
                } catch (error) {

                }

            })
                .catch((err) => {
                    // console.log('ERROR Catch ! ', err);
                })
        } catch (error) {
            // console.log('ERROR : ', error);
        }
    }


    const [isModalAddProductOpen, setIsModalAddProductOpen] = useState(false);
    const ModalAddProductRef = React.useRef()

    const onOpenModalAddProduct = () => {
        setIsModalAddProductOpen(true);
    };
    const onCloseModalAddProduct = () => {
        setIsModalAddProductOpen(false);
        setProductSelected()
        setDataProducts([])
        setColorInput()
        setSizeInput()
        setQuantityInput()
        setPurchase_PriceInput()
    };


    // Modal edit Product

    const [isModalEditProductOpen, setIsModalEditProductOpen] = useState(false);
    const ModalEditProductRef = React.useRef()
    const [idProduct, setIdProduct] = useState()
    const [totalAchat, setTotalAchat] = useState()
    const [oldQtt, setOldQtt] = useState()
    const [oldPurchase_PriceInput, setOldPurchase_PriceInput] = useState()
    const [loadingUpdateModal, setLoadingUpdateModal] = useState(false)

    const onOpenModalEditProduct = () => {
        setIsModalEditProductOpen(true);
    };
    const onCloseModalEditProduct = () => {
        setIsModalEditProductOpen(false);
        setProductSelected()
        setDataProducts([])
        setColorInput()
        setSizeInput()
        setQuantityInput()
        setPurchase_PriceInput()
        setIdProduct()
        setTotalAchat()
        setOldQtt()
        setOldPurchase_PriceInput()
    };

    const [getDataProduct_IdProduct, setGetDataProduct_IdProduct] = useState([])

    useEffect(() => {
        if (idProduct) {
            setLoadingUpdateModal(true)
            axiosClient.get(`produitCommande/${idProduct}/`).then(async (res) => {
                setGetDataProduct_IdProduct(res.data)

                setColorSelected(
                    Array.from(
                        new Map(
                            res.data.produit?.stock
                                .filter(e => e.color.length !== 0)
                                .map(val => ({ value: val.id, label: val.color.toLowerCase() }))
                                .map(item => [item.label.toLowerCase(), item]) // Utilisé pour éliminer les doublons
                        ).values()
                    )
                );

                setSizeSelected(
                    Array.from(
                        new Map(
                            res.data.produit?.stock
                                .filter(e => e.size.length !== 0)
                                .map(val => ({ value: val.id, label: val.size.toLowerCase() }))
                                .map(item => [item.label.toLowerCase(), item]) // Utilisé pour éliminer les doublons
                        ).values()
                    )
                );

                setLoadingUpdateModal(false)
            })
        }
    }, [idProduct])

    const EditProductOrder = async () => {
        try {

            // Validation que quantité et prix sont des nombres si remplis
            if ((quantityInput && !isNumericValid(quantityInput)) ||
                (purchase_PriceInput && !isValidPrice(purchase_PriceInput))) {
                toast({
                    description: t("Le champ quantité doit contenir uniquement des chiffres et le prix un montant valide (ex: 10.22)"),
                    status: 'error',
                    variant: 'left-accent',
                    duration: 2000,
                    isClosable: true,
                    position: 'bottom-right'
                });
                return;
            }


            const qte = quantityInput ? quantityInput : oldQtt
            const prix = purchase_PriceInput ? purchase_PriceInput : oldPurchase_PriceInput

            const payload = {
                idCommande: location.state.id,
            };

            if (colorInput) payload.color = colorInput.label || "";
            if (sizeInput) payload.size = sizeInput.label || "";
            if (quantityInput) payload.quantity = parseInt(quantityInput);
            if (purchase_PriceInput) payload.price = formatPriceForBackend(purchase_PriceInput);

            await axiosClient.patch(`produitCommande/updateProduitCommande/?idProductCommande=${idProduct}`, payload).then(async (res) => {

                await axiosClient.get(`commandes/${location.state.id}/`).then(async (response) => {
                    setDetailOrder(response.data)
                })

                setProductsOrderData(res.data)


                toast({
                    description: t("Produit est modifié avec succès"),
                    status: 'success',
                    duration: 2000,
                    isClosable: true,
                    variant: 'left-accent',
                    position: 'bottom-right'
                })

                onCloseModalEditProduct()

            })
                .catch((err) => {
                    // console.log('ERROR Catch ! ', err);
                })
        } catch (error) {
            // console.log('ERROR : ', error);
        }
    }


    // Delete Product
    const [deleteAlertOpen, setDeleteAlertOpen] = useState(false);
    const deleteAlertRef = React.useRef()
    const [deletedId, setDeletedId] = useState()

    const onOpenDeleteAlert = (id) => {
        setDeleteAlertOpen(true);
        setDeletedId(id)
    };
    const onCloseDeleteAlert = () => {
        setDeleteAlertOpen(false);
        setDeletedId()
    };


    const DeleteProduct = async () => {
        try {
            await axiosClient.delete(`produitCommande/deleteProduitCommande/?idProductCommande=${deletedId}`).then(async (response) => {
                await axiosClient.get(`commandes/${location.state.id}/`).then(async (res) => {
                    setDetailOrder(res.data)
                })
                setProductsOrderData(response.data)
                onCloseDeleteAlert()
                toast({
                    description: t("Produit est supprimé avec succès"),
                    status: 'success',
                    duration: 2000,
                    isClosable: true,
                    variant: 'left-accent',
                    position: 'bottom-right'
                })
            })
        } catch (error) {
            // console.log('ERROR : ', error);
        }
    }

    // Modal edit client infos
    const [isModalClientInfosOpen, setIsModalClientInfosOpen] = useState(false);
    const ModalClientInfosRef = React.useRef()
    const [nomCompletClient, setNomCompletClient] = useState()
    const [emailClient, setEmailClient] = useState()
    const [paysClient, setPaysClient] = useState()
    const [codeCountryClient, setCodeCountryClient] = useState()
    const [villeClient, setVilleClient] = useState()
    const [codeCommande, setCodeCommande] = useState('')

    const countryOptions = countriesData.countries;
    const [adresseClient, setAdresseClient] = useState()
    const [phoneClient, setPhoneClient] = useState()
    const [phoneCode, setPhoneCode] = useState('+212')

    const onOpenModalClientInfos = () => {
        setIsModalClientInfosOpen(true);
        setCodeCommande(detailOrder?.code || '');
        if (detailOrder?.tel) {
            const parts = detailOrder.tel.trim().split(' ');
            if (parts.length > 1 && parts[0].startsWith('+')) {
                setPhoneCode(parts[0]);
                setPhoneClient(parts.slice(1).join(' '));
            } else {
                setPhoneClient(detailOrder.tel);
            }
        }
    };
    const onCloseModalClientInfos = () => {
        setIsModalClientInfosOpen(false);
        setNomCompletClient()
        setEmailClient()
        setPaysClient()
        setCodeCountryClient()
        setVilleClient()
        setAdresseClient()
        setPhoneClient()
        setPhoneCode('+212')
        setCodeCommande('')
    };

    const editClientInfos = async () => {
        try {
            const formData = new FormData()
            nomCompletClient && formData.append('full_name', nomCompletClient)
            formData.append('code', codeCommande || '')
            emailClient && formData.append('email', emailClient)
            paysClient && formData.append('pays', paysClient)
            codeCountryClient && formData.append('code_country', codeCountryClient)
            villeClient && formData.append('ville', villeClient)
            adresseClient && formData.append('address', adresseClient)
            phoneClient && formData.append('tel', `${phoneCode} ${phoneClient}`)
            await axiosClient.patch(`commandes/${location.state.id}/`, formData).then((res) => {
                setDetailOrder(prevData => {
                    return {
                        ...prevData,
                        full_name: res.data.full_name,
                        code: res.data.code,
                        email: res.data.email,
                        pays: res.data.pays,
                        code_country: res.data.code_country,
                        ville: res.data.ville,
                        address: res.data.address,
                        tel: res.data.tel
                    }
                })
                onCloseModalClientInfos()
                toast({
                    description: t("Informations du client sont modifiées avec succès"),
                    status: 'success',
                    duration: 2000,
                    isClosable: true,
                    variant: 'left-accent',
                    position: 'bottom-right'
                })
            })
                .catch((err) => {
                    console.log('ERROR Catch ! ', err);
                    let errMsg = t("Une erreur est survenue lors de la modification.");
                    if (err.response?.data) {
                        const data = err.response.data;
                        if (typeof data === 'string') {
                            errMsg = data;
                        } else if (data.message) {
                            errMsg = data.message;
                        } else if (data.error) {
                            errMsg = data.error;
                        } else {
                            const keys = Object.keys(data);
                            if (keys.length > 0) {
                                const val = data[keys[0]];
                                errMsg = Array.isArray(val) ? val[0] : String(val);
                            }
                        }
                    }
                    toast({
                        description: errMsg,
                        status: 'error',
                        variant: 'left-accent',
                        duration: 4000,
                        isClosable: true,
                        position: 'bottom-right'
                    });
                })
        } catch (error) {
            // console.log('ERROR : ', error);
        }
    }

    const btnMore = useColorModeValue('purple.400', 'purple.200')
    const hoverBtnMore = useColorModeValue('purple.600', 'purple.400')
    const menuItemDelete = useColorModeValue("red", "red.300")
    const bgAddProduct = useColorModeValue('gray.200', 'gray.600')
    const textAddProduct = useColorModeValue('gray.600', 'gray.200')
    const bgCard = useColorModeValue("gray", "gray.400")


    const colorbg = useColorModeValue('white', '#2d3748')

    const txtcolor = useColorModeValue('black', 'white')
    const colorbghover = useColorModeValue('#e2e8f0', '#171923')

    return (
        <Box position={"relative"} mb={5}>

            <Flex>
                <Box w="100%" display={"flex"} justifyContent="space-between" flexDirection={{ base: 'column', md: "row" }} mt={2} mb={{ base: 0, md: 5 }}>
                    <Breadcrumb fontFamily='Plus Jakarta Display' fontStyle={"italic"} fontSize={{ base: "20px", sm: "25px", lg: "27px" }} color="gray">
                        <BreadcrumbItem>
                            <BreadcrumbLink onClick={() => navigate('/')}>{t("Accueil")}</BreadcrumbLink>
                        </BreadcrumbItem>

                        <BreadcrumbItem isCurrentPage>
                            <BreadcrumbLink>{t("Détails commande")}</BreadcrumbLink>
                        </BreadcrumbItem>
                    </Breadcrumb>
                </Box>
            </Flex>

            <Box
                bg={useColorModeValue('white', 'gray.700')}
                p={5}
                rounded='xl'
                mx={5}
            >
                <Flex
                    flexDirection={{ base: 'column', md: 'row' }}
                    justifyContent='space-between'
                    alignItems='center'
                    gap={{ base: 5, md: 0 }}
                >
                    <Flex
                        flexDirection={{ base: 'column', md: 'row' }}
                        alignItems={'center'}
                        gap={4}
                    >
                        <Avatar h={70} w={70} rounded='xl'></Avatar>
                        <Flex flexDirection={"column"}>
                            <Flex alignItems='center' gap={2}>
                                <Text fontSize={15} fontWeight='semibold'>{detailOrder?.full_name}</Text>
                                {(t(`${detailOrder?.status_confirmation}`) !== t('Confirmé')) && (detailOrder?.status_stock === null || detailOrder?.status_stock === '') && (detailOrder?.status_delivery === null || detailOrder?.status_delivery === '') &&
                                    <CiEdit size={20} cursor="pointer" onClick={() => {
                                        if (detailOrder?.assigned_to === user?.id || ["AdminClient", "ManagerClient"].includes(user.role)) {
                                            onOpenModalClientInfos()
                                        }
                                    }} />
                                }
                            </Flex>
                            <Text fontSize={15}>{detailOrder?.tel}</Text>
                            <Text fontSize={13} color={useColorModeValue('gray.400', 'gray.500')}>{`${detailOrder?.pays}, ${detailOrder?.ville}, ${detailOrder?.address}`}</Text>
                            {detailOrder?.email !== 'undefined' && <Text fontSize={13} color={'lightgray'}>{detailOrder?.email}</Text>}
                        </Flex>
                    </Flex>


                    <Flex
                        flexDirection={{ base: 'column', lg: "row" }}
                        gap={3}
                        align='center'>

                        {(t(`${detailOrder?.status_confirmation}`) !== t('Confirmé')) && (detailOrder?.status_stock === null || detailOrder?.status_stock === '') && (detailOrder?.status_delivery === null || detailOrder?.status_delivery === '') &&
                            <Badge
                                colorScheme={
                                    t(`${detailOrder?.status_confirmation}`) !== t('Confirmé')
                                        ? ([t('Mauvais numéro'), t('Annulé')].includes(t(`${detailOrder?.status_confirmation}`)))
                                            ? 'red'
                                            : (t(`${detailOrder?.status_confirmation}`) === t('Nouveau'))
                                                ? 'blue'
                                                : 'orange'
                                        : 'green'
                                }
                                rounded="xl" textAlign='center' minW={120} py={3} px={3} cursor='pointer' textTransform='uppercase' onClick={() => {
                                    if (detailOrder?.assigned_to === user?.id || ["AdminClient", "ManagerClient"].includes(user.role)) {
                                        onOpenAlert()
                                    }
                                }}>
                                <Flex gap={2}>
                                    <MdOutlineHeadsetMic size={18} />
                                    <Text>
                                        {t(`${detailOrder?.status_confirmation}`)}
                                    </Text>
                                </Flex>
                            </Badge>
                        }
                        {(detailOrder?.status_stock !== 'Collecté' && detailOrder?.status_confirmation === 'Confirmé') && (detailOrder?.status_delivery === null || detailOrder?.status_delivery === '') &&
                            <Badge
                                colorScheme={
                                    detailOrder?.status_stock !== 'Collecté'
                                        ? (['Épuisé', 'Annulé'].includes(detailOrder?.status_stock))
                                            ? 'red'
                                            : ([null, ''].includes(detailOrder?.status_stock))
                                                ? 'blue'
                                                : 'orange'
                                        : 'green'
                                }
                                rounded="xl" textAlign='center' minW={120} py={3} px={3} cursor='pointer' textTransform='uppercase' onClick={() => {
                                    if (detailOrder?.assigned_to_stock === user?.id || ["AdminClient", "ManagerClient"].includes(user.role)) {
                                        onOpenAlertStatusStock()
                                    }
                                }}>
                                <Flex gap={2}>
                                    <FaBoxOpen size={18} />
                                    <Text>
                                        {detailOrder?.status_stock ? t(`${detailOrder?.status_stock}`) : t('Nouveau')}
                                    </Text>
                                </Flex>
                            </Badge>
                        }
                        {(detailOrder?.status_stock === "Collecté") &&
                            <Badge
                                colorScheme={
                                    detailOrder?.status_delivery !== 'Livré'
                                        ? (['Refusé', 'Annulé'].includes(detailOrder?.status_delivery))
                                            ? 'red'
                                            : (detailOrder?.status_delivery === 'Nouveau' || detailOrder?.status_delivery === '' || detailOrder?.status_delivery === null)
                                                ? 'blue'
                                                : 'orange'
                                        : 'green'
                                }
                                rounded="xl" textAlign='center' minW={120} py={3} px={3} cursor='pointer' textTransform='uppercase' onClick={() => {
                                    if (detailOrder?.assigned_to === user?.id || ["AdminClient", "ManagerClient"].includes(user.role)) {
                                        onOpenAlertStatusDelivery()
                                    }
                                }}>
                                <Flex gap={2}>
                                    <GrDeliver size={18} />
                                    <Text>
                                        {detailOrder?.status_delivery ? t(`${detailOrder?.status_delivery}`) : t('Nouveau')}
                                    </Text>
                                </Flex>
                            </Badge>
                        }
                        <Badge
                            colorScheme='purple'
                            rounded="xl" textAlign='center' minW={120} py={3} px={3} cursor={detailOrder?.status_confirmation !== 'Confirmé' && 'pointer'} textTransform='uppercase' onClick={() => {
                                {
                                    if (t(`${detailOrder?.status_confirmation}`) !== t('Confirmé') && ((detailOrder?.assigned_to === user?.id || ["AdminClient", "ManagerClient"].includes(user.role)))) {
                                        onOpenAlertCoupon()
                                    }
                                }
                            }}>
                            <Flex gap={2}>
                                <RiCoupon3Fill size={18} />
                                <Text textTransform='capitalize'>
                                    {detailOrder?.couponTitle ? detailOrder?.couponTitle : detailOrder?.status_confirmation !== 'Confirmé' ? t('Ajouter un coupon') : t('Pas de coupon')}
                                </Text>
                            </Flex>
                        </Badge>
                        {((detailOrder?.assigned_to === user?.id && user?.role !== "StockManagerClient") || ["AdminClient", "ManagerClient"].includes(user.role)) && (
                            <Button
                                size="md"
                                onClick={sendToShippingCompany}
                                isLoading={loadingShipping}
                                colorScheme="teal"
                                variant="solid"
                                py={5}
                                px={4}
                                rounded="xl"
                            >
                                {t("Envoyer au transporteur")}
                            </Button>
                        )}
                        <Button

                            _active={'none'}
                            colorScheme='green' variant='outline' w={120} py={3} h={"auto"} rounded='xl' fontSize={15} onClick={onOpenDrawer}>
                            {t("Plus")}
                        </Button>
                    </Flex>



                    {/* {(user.role === "StockManagerClient") && <Flex
                        flexDirection={{ base: 'column', lg: "row" }}
                        gap={3}
                        align='center'>
                        <Badge
                            colorScheme={
                                detailOrder?.status_stock !== 'Collecté'
                                    ? (['Épuisé', 'Annulé'].includes(detailOrder?.status_stock))
                                        ? 'red'
                                        : ([null, ''].includes(detailOrder?.status_stock))
                                            ? 'blue'
                                            : 'orange'
                                    : 'green'
                            }
                            rounded="xl" textAlign='center' minW={120} py={3} px={3} cursor='pointer' textTransform='uppercase' onClick={() => { onOpenAlertStatusStock() }}>
                            <Flex gap={2}>
                                <FaBoxOpen size={18} />
                                <Text>
                                    {detailOrder?.status_stock ? detailOrder?.status_stock : 'Nouveau'}
                                </Text>
                            </Flex>
                        </Badge>
                    </Flex>} */}
                </Flex>
            </Box>

            <Box
                mt={10}
                bg={useColorModeValue('white', 'gray.700')}
                p={5}
                rounded='xl'
                mx={5}
            >
                <Flex justifyContent='space-between'>
                    <Flex alignItems='start'>
                        <Flex align="center" gap={1}>
                            <TiShoppingCart color={useColorModeValue('#a0aec0', '#a0aec0')} size={20} />
                            <Text fontSize={22} fontWeight='semibold'>
                                {t('Panier')}
                            </Text>
                        </Flex>
                    </Flex>
                </Flex>


                <SimpleGrid px={{ base: 2, md: 10 }} mb={5} mt={2} templateColumns={{ base: 'repeat(auto-fill,minmax(250px,1fr))', md: 'repeat(auto-fill,minmax(200px,1fr))' }} spacing={7}>

                    {productsOrderData.map((val, key) => {
                        return (
                            <Card key={key} mt={5} rounded={"xl"} shadow="lg" borderWidth={1} borderColor={'gray.200'}>
                                <CardBody p={0} m={0}>
                                    <Stack position={"relative"}>
                                        <Image
                                            height={"200px"}
                                            src={val.produit?.images[0]?.image}
                                            alt='Image'
                                            objectFit="cover"
                                            roundedTop={"xl"}
                                        />

                                        {(user.role !== "StockManagerClient" &&
                                            // (detailOrder?.status_stock === null || detailOrder?.status_stock === '') && (detailOrder?.status_delivery === null || detailOrder?.status_delivery === '')
                                            detailOrder?.status_confirmation !== 'Confirmé' && (detailOrder?.assigned_to === user?.id || ["AdminClient", "ManagerClient"].includes(user.role))
                                        )
                                            && <Menu>
                                                <MenuButton
                                                    as={IconButton}
                                                    aria-label='Options'
                                                    icon={<CiMenuKebab size={15} />}
                                                    variant='solid'
                                                    position={'absolute'}
                                                    rounded={'full'}
                                                    top={2}
                                                    right={2}
                                                    size={'sm'}
                                                    colorScheme={"blue"}
                                                />
                                                <MenuList>
                                                    <MenuItem icon={<FiEdit3 />} onClick={() => {
                                                        onOpenModalEditProduct()
                                                        setIdProduct(val.id)
                                                        setTotalAchat(val.quantity * val.price)
                                                        setOldQtt(val.quantity)
                                                        setOldPurchase_PriceInput(val.price)
                                                    }}>
                                                        {t("Modifier")}
                                                    </MenuItem>
                                                    {productsOrderData.length > 1 &&
                                                        <MenuItem color={menuItemDelete} icon={<MdDelete color={menuItemDelete} />} onClick={() => {
                                                            onOpenDeleteAlert(val.id)
                                                            setTotalAchat(val.quantity * val.price)
                                                            setOldQtt(val.quantity)
                                                        }}>
                                                            {t("Supprimer")}
                                                        </MenuItem>
                                                    }
                                                </MenuList>
                                            </Menu>}
                                    </Stack>
                                    <Stack p={3} alignItems='start' mt={2}>
                                        <Heading fontSize={'xl'} fontFamily={'body'} fontWeight={500}>
                                            {val.produit?.title}
                                        </Heading>
                                        {val.produit?.code && (
                                            <Badge colorScheme="blue" fontSize="xs" rounded="md" px={2} py={0.5}>
                                                {t('Code')}: {val.produit.code}
                                            </Badge>
                                        )}
                                        {/* <Text lineHeight={5} textAlign={'justify'} color={'descColor'}>
                                            {val.produit?.description}
                                        </Text> */}

                                        <Flex justifyContent="space-between" w='full'>
                                            {val.color && <Flex gap={1} alignItems='center'>
                                                <Text color='gray' fontSize={14}>{t('Couleur')}:</Text>
                                                <Text fontWeight='semibold' fontSize={14} >{val.color}</Text>
                                            </Flex>}
                                            {val.size && <Flex gap={1} alignItems='center'>
                                                <Text color='gray' fontSize={14}>{t('Taille')}:</Text>
                                                <Flex gap={1}>
                                                    <Text fontWeight='semibold' >{val.size}</Text>
                                                </Flex>
                                            </Flex>}
                                        </Flex>

                                        <Flex justifyContent="space-between" w='full'>
                                            <Flex gap={1} alignItems='center'>
                                                <Text color='gray' fontSize={14}>{t('Qté')} :</Text>
                                                <Text fontWeight='semibold' fontSize={12}>{val.quantity}</Text>
                                            </Flex>
                                            <Flex gap={1} alignItems='center'>
                                                <Text color='gray' fontSize={14}>{t('Prix')} :</Text>
                                                <Flex gap={1}>
                                                    <Text fontWeight='semibold' fontSize={14}>{val.price}</Text>
                                                    <Text fontWeight='gray' fontSize={12}>{currentBusiness?.order_currency}</Text>
                                                </Flex>
                                            </Flex>
                                        </Flex>

                                    </Stack>
                                </CardBody>
                            </Card>
                        )
                    })}


                    {(user.role !== "StockManagerClient" &&
                        // (detailOrder?.status_stock === null || detailOrder?.status_stock === '') && (detailOrder?.status_delivery === null || detailOrder?.status_delivery === '')
                        detailOrder?.status_confirmation !== 'Confirmé' && (detailOrder?.assigned_to === user?.id || ["AdminClient", "ManagerClient"].includes(user.role))
                    ) &&
                        <>
                            <Card mt={5} rounded={"2xl"} bg={bgAddProduct} cursor='pointer' onClick={onOpenModalAddProduct}>
                                <CardBody>
                                    <Flex flexDirection="column" align={'center'} justify={'center'} h={'full'}>
                                        <Text color={textAddProduct}><MdAdd size={25} /></Text>
                                        <Text color={textAddProduct} fontWeight='semibold'>{t('Nouveau produit')}</Text>
                                    </Flex>
                                </CardBody>
                            </Card>
                        </>
                    }

                </SimpleGrid>

            </Box>

            <Box
                mt={10}
                // bg={useColorModeValue('white', 'gray.700')}
                // p={5}
                rounded='xl'
                mx={5}>
                <SimpleGrid columns={{ base: 1, md: 2, lg: 2, xl: 3 }} spacing={{ base: 5, lg: 8 }}>
                    <Stat
                        px={{ base: 2, md: 4 }}
                        py={'5'}
                        shadow={'xl'}
                        bg={useColorModeValue('white', 'gray.700')}
                        rounded={'lg'}>
                        <Flex justifyContent={'space-between'}>
                            <Box pl={{ base: 2, md: 4 }}>
                                <StatLabel fontWeight={'medium'} isTruncated>
                                    <Text color='gray'>{t('Produit')}</Text>
                                </StatLabel>
                                <StatNumber fontSize={'2xl'} fontWeight={'medium'} >
                                    <Text fontWeight='semibold'>{productsOrderData?.length} </Text>
                                </StatNumber>
                            </Box>
                            <Box
                                my={'auto'}
                                color={useColorModeValue('purple.500', 'purple.300')}
                                alignContent={'center'}>
                                {<FaBoxOpen size={'3em'} />}
                            </Box>
                        </Flex>
                    </Stat>
                    <Stat
                        px={{ base: 2, md: 4 }}
                        py={'5'}
                        shadow={'xl'}
                        bg={useColorModeValue('white', 'gray.700')}
                        rounded={'lg'}>
                        <Flex justifyContent={'space-between'}>
                            <Box pl={{ base: 2, md: 4 }}>
                                <StatLabel fontWeight={'medium'} isTruncated>
                                    <Text color='gray'>{t('Quantité')}</Text>
                                </StatLabel>
                                <StatNumber fontSize={'2xl'} fontWeight={'medium'}>
                                    <Text fontWeight='semibold'>{detailOrder?.quantity_total}</Text>
                                </StatNumber>
                            </Box>
                            <Box
                                my={'auto'}
                                color={useColorModeValue('blue.500', 'blue.300')}
                                alignContent={'center'}>
                                {<BsCart4 size={'3em'} />}
                            </Box>
                        </Flex>
                    </Stat>
                    <Stat
                        px={{ base: 2, md: 4 }}
                        py={'5'}
                        shadow={'xl'}
                        bg={useColorModeValue('white', 'gray.700')}
                        rounded={'lg'}>
                        <Flex justifyContent={'space-between'}>
                            <Box pl={{ base: 2, md: 4 }}>
                                <StatLabel fontWeight={'medium'} isTruncated>
                                    <Text color='gray'>{t('Total prix')}</Text>
                                </StatLabel>
                                <StatNumber fontSize={'2xl'} fontWeight={'medium'}>
                                    <Flex gap={1}>
                                        <Flex alignItems="center" gap={1}>
                                            <Text color={detailOrder?.coupon && 'gray.400'} fontSize={detailOrder?.coupon && 15} fontWeight='semibold' textDecoration={detailOrder?.coupon && 'line-through'}>{detailOrder?.price}</Text>
                                            <Text h={"100%"} fontSize={12} >{currentBusiness?.order_currency}</Text>
                                        </Flex>
                                        {detailOrder?.coupon &&
                                            <>
                                                /
                                                <Flex alignItems="center" gap={1}>
                                                    <Text fontWeight='semibold'>{detailOrder?.priceWithCoupon}</Text>
                                                    <Text h={"100%"} fontSize={12} >{currentBusiness?.order_currency}</Text>
                                                </Flex>
                                            </>
                                        }
                                    </Flex>
                                </StatNumber>
                            </Box>
                            <Box
                                my={'auto'}
                                color={useColorModeValue('green.500', 'green.300')}
                                alignContent={'center'}>
                                {<IoMdPricetags size={'3em'} />}
                            </Box>
                        </Flex>
                    </Stat>
                    {/* <StatsCard title={'Servers'} stat={'1,000'} icon={<FiServer size={'3em'} />} />
                    <StatsCard title={'Datacenters'} stat={'7'} icon={<GoLocation size={'3em'} />} /> */}
                </SimpleGrid>
            </Box>


            {/* Alert to Update confirmation status */}

            <AlertDialog
                isOpen={isAlertOpen}
                leastDestructiveRef={cancelRef}
                onClose={onCloseAlert}
            >
                <AlertDialogOverlay>
                    <AlertDialogContent>
                        <AlertDialogHeader fontSize='lg' fontWeight='bold'>
                            {t('Statut de confirmation')}
                        </AlertDialogHeader>

                        <AlertDialogBody>
                            <Text>
                                {t("Ici, vous pouvez modifier le statut de confirmation.")}
                            </Text>

                            <Select
                                mt={3}
                                rounded='lg'
                                size={"sm"}
                                value={statusConfirmation}
                                onChange={e => setStatusConfirmation(e.target.value)}
                            >
                                <option value=''>{t('Statut de confirmation')}</option>
                                <option value='Pas de réponse'>{t('Pas de réponse')}</option>
                                <option value='Messagerie vocale'>{t('Messagerie vocale')}</option>
                                <option value='En attente'>{t('En attente')}</option>
                                <option value='Ligne occupée'>{t('Ligne occupée')}</option>
                                <option value='Mauvais numéro'>{t('Mauvais numéro')}</option>
                                <option value='Annulé'>{t('Annulé')}</option>
                                <option value='Confirmé'>{t('Confirmé')}</option>
                            </Select>
                        </AlertDialogBody>

                        <AlertDialogFooter>
                            <Button colorScheme='yellow' size="sm" variant='outline' isDisabled={!statusConfirmation} mr={3} onClick={HandleChangeStatus}>
                                {t("Modifier")}
                            </Button>
                            <Button onClick={onCloseAlert} size="sm" >{t("Annuler")}</Button>
                        </AlertDialogFooter>
                    </AlertDialogContent>
                </AlertDialogOverlay>
            </AlertDialog>


            {/* Alert to Update stock status */}

            <AlertDialog
                isOpen={isAlertOpenStatusStock}
                leastDestructiveRef={cancelRefStatusStock}
                onClose={onCloseAlertStatusStock}
            >
                <AlertDialogOverlay>
                    <AlertDialogContent>
                        <AlertDialogHeader fontSize='lg' fontWeight='bold'>
                            {t('Statut de stock')}
                        </AlertDialogHeader>

                        <AlertDialogBody>
                            <Text>
                                {t("Ici, vous pouvez modifier le statut de stock.")}
                            </Text>

                            <Select
                                mt={3}
                                rounded='lg'
                                size={"sm"}
                                value={statusStock}
                                onChange={e => setStatusStock(e.target.value)}
                            >
                                <option value=''>{t('Statut de stock')}</option>
                                <option value='Épuisé'>{t('Épuisé')}</option>
                                <option value='Annulé'>{t('Annulé')}</option>
                                <option value='En cours'>{t('En cours')}</option>
                                <option value='Emballé'>{t('Emballé')}</option>
                                <option value='Collecté'>{t('Collecté')}</option>
                            </Select>
                        </AlertDialogBody>

                        <AlertDialogFooter>
                            <Button colorScheme='yellow' size="sm" variant='outline' isDisabled={!statusStock} mr={3} onClick={HandleChangeStatusStock}>
                                {t("Modifier")}
                            </Button>
                            <Button onClick={onCloseAlertStatusStock} size="sm" >{t("Annuler")}</Button>
                        </AlertDialogFooter>
                    </AlertDialogContent>
                </AlertDialogOverlay>
            </AlertDialog>


            {/* Alert to Update stock delivery */}

            <AlertDialog
                isOpen={isAlertOpenStatusDelivery}
                leastDestructiveRef={cancelRefStatusDelivery}
                onClose={onCloseAlertStatusDelivery}
            >
                <AlertDialogOverlay>
                    <AlertDialogContent>
                        <AlertDialogHeader fontSize='lg' fontWeight='bold'>
                            {t('Statut de livraison')}
                        </AlertDialogHeader>

                        <AlertDialogBody>
                            <Text>
                                {t("Ici, vous pouvez modifier le statut de livraison.")}
                            </Text>

                            <Select
                                mt={3}
                                rounded='lg'
                                size={"sm"}
                                value={statusDelivery}
                                onChange={e => setStatusDelivery(e.target.value)}
                            >
                                <option value="">{t("Statut de livraison")}</option>
                                <option value='Ramassé'>{t('Ramassé')}</option>
                                <option value='Expédié'>{t('Expédié')}</option>
                                <option value='Reçu à destination'>{t('Reçu à destination')}</option>
                                <option value='Pendant la distribution'>{t('Pendant la distribution')}</option>
                                <option value='Programmé'>{t('Programmé')}</option>
                                <option value='Hors zone'>{t('Hors zone')}</option>
                                <option value='Non atteint'>{t('Non atteint')}</option>
                                <option value='Annulé'>{t('Annulé')}</option>
                                <option value='Refusé'>{t('Refusé')}</option>
                                <option value='Livré'>{t('Livré')}</option>
                                <option value='Préparation du retour'>{t('Préparation du retour')}</option>
                                <option value="Retour à l'agence">{t("Retour à l'agence")}</option>
                                <option value="Retour à l'entrepôt">{t("Retour à l'entrepôt")}</option>
                            </Select>
                        </AlertDialogBody>

                        <AlertDialogFooter>
                            <Button colorScheme='yellow' size="sm" variant='outline' isDisabled={!statusDelivery} mr={3} onClick={HandleChangeStatusDelivery}>
                                {t("Modifier")}
                            </Button>
                            <Button onClick={onCloseAlertStatusDelivery} size="sm" >{t("Annuler")}</Button>
                        </AlertDialogFooter>
                    </AlertDialogContent>
                </AlertDialogOverlay>
            </AlertDialog>


            {/* Alert to Add or Update Coupon */}

            <AlertDialog
                isOpen={isAlertOpenCoupon}
                leastDestructiveRef={cancelRefCoupon}
                onClose={onCloseAlertCoupon}
            >
                <AlertDialogOverlay>
                    <AlertDialogContent>
                        <AlertDialogHeader fontSize='lg' fontWeight='bold'>
                            {t('Coupon')}
                        </AlertDialogHeader>

                        <AlertDialogBody>
                            <Text>
                                {t("Ici, vous pouvez ajouter, modifier ou supprimer le coupon.")}
                            </Text>

                            <Select
                                mt={3}
                                rounded='lg'
                                size={"sm"}
                                defaultValue={detailOrder?.coupon ? detailOrder?.coupon : couponSelected}
                                onChange={e => setCouponSelected(e.target.value)}
                            >
                                <option value=''>{t('Coupon')}</option>
                                {dataCoupon.map((val, key) => {
                                    return (
                                        <option key={key} value={val.id}>{val.code}</option>
                                    )
                                })}
                            </Select>
                        </AlertDialogBody>

                        <AlertDialogFooter>
                            <Flex justifyContent="space-between" w="100%">
                                <Flex>
                                    <Button onClick={deleteCoupon} size="sm" colorScheme='red' >{t("Supprimer")}</Button>
                                </Flex>
                                <Flex>
                                    <Button colorScheme='yellow' size="sm" variant='outline' isDisabled={!couponSelected} mr={3} onClick={HandleChangeCoupon}>
                                        {t("Modifier")}
                                    </Button>
                                    <Button onClick={onCloseAlertCoupon} size="sm" >{t("Annuler")}</Button>
                                </Flex>
                            </Flex>
                        </AlertDialogFooter>
                    </AlertDialogContent>
                </AlertDialogOverlay>
            </AlertDialog>


            {/* Drawer */}
            <Drawer size={{ sm: 'full', md: 'md' }} placement={"right"} onClose={onCloseDrawer} isOpen={isDrawerOpen}>
                <DrawerOverlay />
                <DrawerContent>
                    <DrawerCloseButton />
                    <DrawerHeader borderBottomWidth='1px'>{t("Informations client")}</DrawerHeader>
                    <DrawerBody>
                        <Flex flexDirection="column" gap={2}>
                            {
                                dataInfoClient.length > 0 ?
                                    dataInfoClient.map((val, key) => {
                                        return (
                                            <Flex align="center" justify="space-between" key={key}>
                                                <Flex gap={1}>
                                                    <Text>ID : </Text>
                                                    <Text fontWeight={500}>{val.code}</Text>
                                                </Flex>
                                                <Badge display='flex' gap={1} bg='gray' rounded="xl" textAlign='center' minW={120} py={3} px={3}>
                                                    <Text fontSize='xs' fontWeight={500} color={"black"}>{t(val.status_name)} :</Text>
                                                    <Text size="md" color={"white"}>{t(val.status)}</Text>
                                                </Badge>
                                            </Flex>
                                        )
                                    })
                                    :
                                    <Flex>
                                        <Text>{t("Aucune donnée n'a été trouvée.")}</Text>
                                    </Flex>
                            }
                        </Flex>
                    </DrawerBody>
                </DrawerContent>
            </Drawer>



            {/* Modal to add product in order */}
            <Modal size="lg" closeOnOverlayClick={ModalAddProductRef} isOpen={isModalAddProductOpen} onClose={onCloseModalAddProduct}>
                <ModalOverlay />
                <ModalContent>
                    <ModalHeader>{t("Ajout du produit")} </ModalHeader>
                    <ModalCloseButton />
                    <ModalBody pb={6}>

                        <FormControl isRequired >
                            <FormLabel>
                                {t("Liste des produits")}
                            </FormLabel>
                            <AsyncPaginate
                                loadOptions={loadProductOptions}
                                additional={{ page: 1 }}
                                onChange={setProductSelected}
                                value={productSelected}
                                name='produit'
                                placeholder={t("Produit")}
                                isClearable={true}
                                noOptionsMessage={() => t("Aucun produit trouvé")}
                                styles={{

                                    control: (baseStyles, state) => ({
                                        ...baseStyles,
                                        backgroundColor: 'transparent',
                                        borderColor: 'gray.200'

                                    }),
                                    menu: (provided) => ({
                                        ...provided,
                                        textAlign: 'left',
                                        backgroundColor: colorbg,
                                        cursor: "pointer",
                                        zIndex: 9999
                                    }),
                                    option: (provided, state) => ({
                                        backgroundColor: colorbg,

                                        ...provided,
                                        color: txtcolor,
                                        backgroundColor: state.isSelected ? colorbg : 'inherit',
                                        '&:hover': {
                                            backgroundColor: colorbghover,
                                        },

                                        cursor: "pointer"
                                    }),
                                    singleValue: (provided) => ({
                                        ...provided,
                                        color: txtcolor,
                                    }),

                                }}
                            />
                        </FormControl>

                        {dataProducts.length !== 0 &&
                            <>
                                <Flex justifyContent={'center'} my={2}>
                                    <Avatar
                                        h={150}
                                        w={150}
                                        borderRadius='12px'
                                        me='18px'
                                        name='image'
                                        src={imageProduct} />
                                </Flex>

                                <Flex flexDirection={"row"} gap={2}>
                                    {colorSelected.length !== 0 &&
                                        <FormControl>
                                            <FormLabel>{t("Couleur")}</FormLabel>
                                            <ReactSelect
                                                onChange={setColorInput}
                                                value={colorInput}
                                                name='colorInput'
                                                options={colorSelected}
                                                placeholder={t("Couleur")}
                                                isClearable
                                                styles={{

                                                    control: (baseStyles, state) => ({
                                                        ...baseStyles,
                                                        backgroundColor: 'transparent',
                                                        borderColor: 'gray.200'

                                                    }),
                                                    menu: (provided) => ({
                                                        ...provided,
                                                        textAlign: 'left',
                                                        backgroundColor: colorbg,
                                                        cursor: "pointer"
                                                    }),
                                                    option: (provided, state) => ({
                                                        backgroundColor: colorbg,

                                                        ...provided,
                                                        color: txtcolor,
                                                        backgroundColor: state.isSelected ? colorbg : 'inherit',
                                                        '&:hover': {
                                                            backgroundColor: colorbghover,
                                                        },

                                                        cursor: "pointer"
                                                    }),
                                                    singleValue: (provided) => ({
                                                        ...provided,
                                                        color: txtcolor,
                                                    }),

                                                }}
                                            />
                                        </FormControl>
                                    }

                                    {sizeSelected.length !== 0 &&
                                        <FormControl>
                                            <FormLabel>{t("Taille")}</FormLabel>
                                            <ReactSelect
                                                onChange={setSizeInput}
                                                value={sizeInput}
                                                name='SizeInput'
                                                options={sizeSelected}
                                                placeholder={t("Taille")}
                                                isClearable
                                                styles={{

                                                    control: (baseStyles, state) => ({
                                                        ...baseStyles,
                                                        backgroundColor: 'transparent',
                                                        borderColor: 'gray.200'

                                                    }),
                                                    menu: (provided) => ({
                                                        ...provided,
                                                        textAlign: 'left',
                                                        backgroundColor: colorbg,
                                                        cursor: "pointer"
                                                    }),
                                                    option: (provided, state) => ({
                                                        backgroundColor: colorbg,

                                                        ...provided,
                                                        color: txtcolor,
                                                        backgroundColor: state.isSelected ? colorbg : 'inherit',
                                                        '&:hover': {
                                                            backgroundColor: colorbghover,
                                                        },

                                                        cursor: "pointer"
                                                    }),
                                                    singleValue: (provided) => ({
                                                        ...provided,
                                                        color: txtcolor,
                                                    }),

                                                }}
                                            />
                                        </FormControl>
                                    }
                                </Flex>

                                <Flex mt={3} gap={2}>
                                    <FormControl isRequired>
                                        <FormLabel>{t("Quantité")}</FormLabel>
                                        <Input
                                            placeholder={t('Quantité')}
                                            defaultValue={quantityInput}
                                            onChange={e => setQuantityInput(e.target.value)}
                                        />
                                    </FormControl>

                                    <FormControl isRequired>
                                        <FormLabel display="flex" alignItems="center" gap={1}>
                                            <Text>{t("Prix d'achat")}</Text>
                                            <Text fontSize={12} >{currentBusiness?.order_currency}</Text>
                                        </FormLabel>
                                        <Input
                                            placeholder={t("Prix d'achat")}
                                            value={purchase_PriceInput}
                                            onChange={e => {
                                                const val = handlePriceChange(e.target.value);
                                                if (val !== null) setPurchase_PriceInput(val);
                                            }}
                                        />
                                    </FormControl>

                                </Flex>
                            </>
                        }
                    </ModalBody>

                    <ModalFooter>
                        <Button colorScheme='blue' size="sm" variant='outline' mr={3} onClick={addProduct}>
                            {t("Ajouter")}
                        </Button>
                        <Button onClick={onCloseModalAddProduct} size="sm" >{t("Annuler")}</Button>
                    </ModalFooter>
                </ModalContent>
            </Modal>


            {/* Modal to edit product in order */}
            <Modal size="lg" closeOnOverlayClick={ModalEditProductRef} isOpen={isModalEditProductOpen} onClose={onCloseModalEditProduct}>
                <ModalOverlay />
                <ModalContent>
                    <ModalHeader>{t("Modification du produit")}</ModalHeader>
                    <ModalCloseButton />
                    {!loadingUpdateModal &&
                        <ModalBody pb={6}>

                            <Text fontWeight='semibold' fontSize={18}>{getDataProduct_IdProduct.produit?.title}</Text>
                            {getDataProduct_IdProduct.produit?.code && (
                                <Badge colorScheme="blue" fontSize="xs" rounded="md" px={2} py={0.5} mt={1} mb={2}>
                                    {t('Code')}: {getDataProduct_IdProduct.produit.code}
                                </Badge>
                            )}

                            <Flex justifyContent={'center'} my={2}>
                                <Avatar
                                    h={150}
                                    w={150}
                                    borderRadius='12px'
                                    me='18px'
                                    name='image'
                                    src={getDataProduct_IdProduct.produit?.images[0]?.image} />
                            </Flex>

                            <Flex flexDirection={"row"} gap={2}>
                                {colorSelected?.length !== 0 &&
                                    <FormControl isRequired>
                                        <FormLabel>{t("Couleur")}</FormLabel>
                                        <ReactSelect
                                            onChange={setColorInput}
                                            value={
                                                colorInput
                                                    ? colorInput
                                                    : {
                                                        value: colorSelected?.find(e => e.label === getDataProduct_IdProduct?.color)?.value,
                                                        label: getDataProduct_IdProduct?.color
                                                    }
                                            }
                                            name='colorInput'
                                            options={colorSelected}
                                            placeholder={t("Couleur")}
                                            styles={{

                                                control: (baseStyles, state) => ({
                                                    ...baseStyles,
                                                    backgroundColor: 'transparent',
                                                    borderColor: 'gray.200'

                                                }),
                                                menu: (provided) => ({
                                                    ...provided,
                                                    textAlign: 'left',
                                                    backgroundColor: colorbg,
                                                    cursor: "pointer"
                                                }),
                                                option: (provided, state) => ({
                                                    backgroundColor: colorbg,

                                                    ...provided,
                                                    color: txtcolor,
                                                    backgroundColor: state.isSelected ? colorbg : 'inherit',
                                                    '&:hover': {
                                                        backgroundColor: colorbghover,
                                                    },

                                                    cursor: "pointer"
                                                }),
                                                singleValue: (provided) => ({
                                                    ...provided,
                                                    color: txtcolor,
                                                }),

                                            }}
                                        />
                                    </FormControl>
                                }

                                {sizeSelected?.length !== 0 &&
                                    <FormControl isRequired>
                                        <FormLabel>{t("Taille")}</FormLabel>
                                        <ReactSelect
                                            onChange={setSizeInput}
                                            value={
                                                sizeInput
                                                    ? sizeInput
                                                    : {
                                                        value: colorSelected?.find(e => e.label === getDataProduct_IdProduct?.size)?.value,
                                                        label: getDataProduct_IdProduct?.size
                                                    }
                                            }
                                            name='sizeInput'
                                            options={sizeSelected}
                                            placeholder={t("Taille")}
                                            styles={{

                                                control: (baseStyles, state) => ({
                                                    ...baseStyles,
                                                    backgroundColor: 'transparent',
                                                    borderColor: 'gray.200'

                                                }),
                                                menu: (provided) => ({
                                                    ...provided,
                                                    textAlign: 'left',
                                                    backgroundColor: colorbg,
                                                    cursor: "pointer"
                                                }),
                                                option: (provided, state) => ({
                                                    backgroundColor: colorbg,

                                                    ...provided,
                                                    color: txtcolor,
                                                    backgroundColor: state.isSelected ? colorbg : 'inherit',
                                                    '&:hover': {
                                                        backgroundColor: colorbghover,
                                                    },

                                                    cursor: "pointer"
                                                }),
                                                singleValue: (provided) => ({
                                                    ...provided,
                                                    color: txtcolor,
                                                }),

                                            }}
                                        />
                                    </FormControl>
                                }
                            </Flex>

                            <Flex mt={3} gap={2}>
                                <FormControl isRequired>
                                    <FormLabel>{t("Quantité")}</FormLabel>
                                    <Input
                                        placeholder={t('Quantité')}
                                        defaultValue={getDataProduct_IdProduct?.quantity}
                                        onChange={e => setQuantityInput(e.target.value)}
                                    />
                                </FormControl>

                                <FormControl isRequired>
                                    <FormLabel display="flex" alignItems="center" gap={1}>
                                        <Text>{t("Prix d'achat")}</Text>
                                        <Text fontSize={12} >{currentBusiness?.order_currency}</Text>
                                    </FormLabel>
                                    <Input
                                        placeholder={t("Prix d'achat")}
                                        value={purchase_PriceInput !== undefined ? purchase_PriceInput : getDataProduct_IdProduct?.price}
                                        onChange={e => {
                                            const val = handlePriceChange(e.target.value);
                                            if (val !== null) setPurchase_PriceInput(val);
                                        }}
                                    />
                                </FormControl>

                            </Flex>

                        </ModalBody>
                    }

                    <ModalFooter>
                        <Button colorScheme='blue' size="sm" variant='outline' mr={3} onClick={EditProductOrder}>
                            {t("Modifier")}
                        </Button>
                        <Button onClick={onCloseModalEditProduct} size="sm" >{t("Annuler")}</Button>
                    </ModalFooter>
                </ModalContent>
            </Modal>


            {/* Alert to Delete Product */}

            <AlertDialog
                isOpen={deleteAlertOpen}
                leastDestructiveRef={deleteAlertRef}
                onClose={onCloseDeleteAlert}
            >
                <AlertDialogOverlay>
                    <AlertDialogContent>
                        <AlertDialogHeader fontSize='lg' fontWeight='bold'>
                            {t("Supprimer")}
                        </AlertDialogHeader>

                        <AlertDialogBody>
                            {t("êtes-vous sûr ? Vous ne pourrez pas annuler cette action ultérieurement.")}
                        </AlertDialogBody>

                        <AlertDialogFooter>
                            <Button ref={deleteAlertRef} onClick={onCloseDeleteAlert}>
                                {t("Annuler")}
                            </Button>
                            <Button onClick={DeleteProduct} colorScheme='red' ml={3}>
                                {t("Supprimer")}
                            </Button>
                        </AlertDialogFooter>
                    </AlertDialogContent>
                </AlertDialogOverlay>
            </AlertDialog>


            {/* Modal to edit client infox */}
            <Modal size="2xl" closeOnOverlayClick={ModalClientInfosRef} isOpen={isModalClientInfosOpen} onClose={onCloseModalClientInfos}>
                <ModalOverlay />
                <ModalContent>
                    <ModalHeader>{t("Modification des infos du client")}</ModalHeader>
                    <ModalCloseButton />
                    <ModalBody pb={6}>

                        <Flex>
                            <Text color={bgCard}>{t("Informations client")}</Text>
                        </Flex>
                        <Flex gap={4} flexDirection={{ base: 'column', md: 'row' }}>
                            <FormControl isRequired>
                                <FormLabel>
                                    {t("Nom complet")}
                                </FormLabel>
                                <Input type='text' placeholder={t('Nom complet')} defaultValue={detailOrder?.full_name} onChange={e => setNomCompletClient(e.target.value)} />
                            </FormControl>
                            <FormControl>
                                <FormLabel>
                                    {t("Code (optionnel)")}
                                </FormLabel>
                                <Input type='text' placeholder={t('Laisser vide pour générer automatiquement')} value={codeCommande} onChange={e => setCodeCommande(e.target.value)} />
                            </FormControl>
                        </Flex>
                        <Flex gap={4} flexDirection={{ base: 'column', md: 'row' }}>
                            <FormControl>
                                <FormLabel>
                                    Email {t("(optionnel)")}
                                </FormLabel>
                                <Input type='email' placeholder='Email' defaultValue={detailOrder?.email} onChange={e => setEmailClient(e.target.value)} />
                            </FormControl>
                            <FormControl isRequired>
                                <FormLabel>
                                    {t("Pays")}
                                </FormLabel>
                                <ReactSelect
                                    options={countryOptions}
                                    placeholder={t('Sélectionnez un pays')}
                                    onChange={(selected) => {
                                        setPaysClient(selected ? selected.label : '');
                                        setCodeCountryClient(selected ? selected.value : '');
                                        if (selected?.phoneCode) setPhoneCode(selected.phoneCode);
                                    }}
                                    value={countryOptions.find(opt => opt.value === (codeCountryClient || detailOrder?.code_country)) || null}
                                    styles={{
                                        control: (baseStyles) => ({
                                            ...baseStyles,
                                            backgroundColor: 'transparent',
                                            borderColor: 'gray.200'
                                        }),
                                        menu: (provided) => ({
                                            ...provided,
                                            textAlign: 'left',
                                            backgroundColor: colorbg,
                                            cursor: "pointer"
                                        }),
                                        option: (provided, state) => ({
                                            backgroundColor: colorbg,
                                            ...provided,
                                            color: txtcolor,
                                            backgroundColor: state.isSelected ? colorbg : 'inherit',
                                            '&:hover': {
                                                backgroundColor: colorbghover,
                                            },
                                            cursor: "pointer"
                                        }),
                                        singleValue: (provided) => ({
                                            ...provided,
                                            color: txtcolor,
                                        }),
                                    }}
                                />
                            </FormControl>
                        </Flex>
                        <Flex gap={4} flexDirection={{ base: 'column', md: 'row' }}>
                            <FormControl isRequired>
                                <FormLabel>
                                    {t("Ville")}
                                </FormLabel>
                                <Input type='text' placeholder={t('Ville')} defaultValue={detailOrder?.ville} onChange={e => setVilleClient(e.target.value)} />
                            </FormControl>
                            <FormControl isRequired>
                                <FormLabel>
                                    {t("Adresse")}
                                </FormLabel>
                                <Input type='text' placeholder={t('Adresse')} defaultValue={detailOrder?.address} onChange={e => setAdresseClient(e.target.value)} />
                            </FormControl>
                        </Flex>
                        <Flex gap={4} flexDirection={{ base: 'column', md: 'row' }}>
                            <FormControl isRequired w={{ base: "100%", md: "50%" }}>
                                <FormLabel>
                                    {t("N°téléphone")}
                                </FormLabel>
                                <Flex
                                    alignItems="center"
                                    borderWidth="1px"
                                    borderColor="var(--chakra-colors-gray-200)"
                                    borderRadius="md"
                                    _focusWithin={{
                                        borderColor: "blue.500",
                                        boxShadow: "0 0 0 1px #3182ce"
                                    }}
                                    bg="transparent"
                                    transition="all 0.2s"
                                >
                                    <Box width="140px" borderRight="1px solid" borderColor="var(--chakra-colors-gray-200)">
                                        <ReactSelect
                                            options={countryOptions.map((c) => ({
                                                value: c.phoneCode,
                                                label: `${c.label.split(' ')[0]} ${c.phoneCode}`,
                                                fullLabel: `${c.label} (${c.phoneCode})`,
                                                countryValue: c.value,
                                                countryLabel: c.label
                                            }))}
                                            value={{ value: phoneCode, label: phoneCode }}
                                            onChange={(selected) => {
                                                setPhoneCode(selected.value);
                                                if (selected.countryValue) {
                                                    setCodeCountryClient(selected.countryValue);
                                                    setPaysClient(selected.countryLabel);
                                                }
                                            }}
                                            formatOptionLabel={(data, { context }) => (
                                                context === 'menu' ? data.fullLabel : data.label
                                            )}
                                            styles={{
                                                control: (baseStyles) => ({
                                                    ...baseStyles,
                                                    backgroundColor: 'transparent',
                                                    borderColor: 'transparent',
                                                    boxShadow: 'none',
                                                    cursor: "pointer",
                                                    "&:hover": { borderColor: "transparent" }
                                                }),
                                                menu: (provided) => ({
                                                    ...provided,
                                                    backgroundColor: colorbg,
                                                    zIndex: 9999,
                                                    width: '280px'
                                                }),
                                                option: (provided, state) => ({
                                                    ...provided,
                                                    backgroundColor: state.isSelected ? colorbg : 'inherit',
                                                    color: txtcolor,
                                                    '&:hover': {
                                                        backgroundColor: colorbghover,
                                                    },
                                                    cursor: "pointer"
                                                }),
                                                singleValue: (provided) => ({
                                                    ...provided,
                                                    color: txtcolor,
                                                    fontWeight: "600"
                                                }),
                                                dropdownIndicator: (provided) => ({
                                                    ...provided,
                                                    padding: "4px"
                                                })
                                            }}
                                        />
                                    </Box>
                                    <Input
                                        type='tel'
                                        pattern="^[0-9]*$"
                                        variant="unstyled"
                                        pl={3}
                                        py={2}
                                        height="100%"
                                        placeholder={t("N°téléphone")}
                                        value={phoneClient || ''}
                                        onChange={e => {
                                            const val = e.target.value;
                                            if (val === '' || /^[0-9]*$/.test(val)) {
                                                setPhoneClient(val);
                                            }
                                        }}
                                    />
                                </Flex>
                            </FormControl>
                        </Flex>

                    </ModalBody>

                    <ModalFooter>
                        <Button colorScheme='blue' size="sm" variant='outline' mr={3} onClick={editClientInfos}>
                            {t("Modifier")}
                        </Button>
                        <Button onClick={onCloseModalClientInfos} size="sm" >{t("Annuler")}</Button>
                    </ModalFooter>
                </ModalContent>
            </Modal>


        </Box>
    )
}

export default Details_GestConfirmation